import {Button, Dialog, DialogContent, DialogTitle, Grid} from "@mui/material";
import QuantitySelector from "../ProductDetail/QuantitySelector";
import React, {useEffect, useState} from "react";
import { Product } from "../../types/Product";
import { BUTTON_STYLES } from "../../styles/buttonStyles";
import { getMinimumPurchaseQuantity } from "../../utils/purchaseRules";

interface AddToCartQuantityDialogProps {
  open: boolean,
  product: Product,
  variant: any,
  onClose: () => void,
}

function AddToCartQuantityDialog(props: AddToCartQuantityDialogProps) {
  const minimumPurchase = getMinimumPurchaseQuantity();
  const [quantity, setQuantity] = useState<number>(minimumPurchase);

  useEffect(() => {
    if (!props.open && quantity !== minimumPurchase) setQuantity(minimumPurchase);
  }, [props.open, quantity, minimumPurchase]);
  
  return (
    <Dialog open={props.open}
            onClose={props.onClose}
            maxWidth={'sm'}
            fullWidth
    >
      <DialogTitle>
        Cantidad a sumar a tu pedido
      </DialogTitle>
      
      <DialogContent>
        <Grid container>
          <Grid size={12}>
            <QuantitySelector productId={props.product.id}
                              variantId={props.variant?.id}
                              productName={props.product.nombre}
                              productPrice={props.variant?.price || 0}
                              productImage={props.product.urlImagenPrincipal}
                              quantity={quantity}
                              stock={props.variant?.stock}
                              onQuantityChange={setQuantity}
                              minQuantity={minimumPurchase}
                              onAfterAddToCart={props.onClose}
                              attributes={props.variant?.attributes}
            />
          </Grid>
          <Grid size={12}>
            <Button 
              variant={'text'}
              size={'small'}
              onClick={props.onClose}
              sx={BUTTON_STYLES.borderedText}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default AddToCartQuantityDialog;














